const dossier_scopes = {
    DOSSIER_GET : 'dossier:dossier:get', // '/dossier/id'
    DOSSIER_LIST : 'dossier:dossier:list', // '/dossiers'
};

export default dossier_scopes;
